import { INTERACTION_FALLBACK_DELAY_MS } from "../utils/afterPageLoad";
import { useAfterLoadDelay } from "./useAfterLoadDelay";
import { useInteract } from "./useInteract";

// True once the visitor first interacts with the page (useInteract), or `delayMs`
// after the window's load event (useAfterLoadDelay), whichever comes first.
export function useAfterInteractionOrDelay(
  delayMs: number = INTERACTION_FALLBACK_DELAY_MS,
): boolean {
  const hasInteracted = useInteract();
  const isDelayOver = useAfterLoadDelay(delayMs);
  return hasInteracted || isDelayOver;
}
